import { actions as handsActions } from '../../../slices/handsSlice'
import API from '../../../../axios'
import { actions as trainerActions } from '../../../slices/trainer'

export const getAssistanceByData = (spot_id, players, isHero, stacks, hands, trace, replaceResponse=false) => async (dispatch) => {

	try {
		dispatch(handsActions.setIsLoadingGPTResponse(true))

		// set rate to null
		if (replaceResponse){

		}

		// preprocess data
		const reqPlayers = players.map((position, index) => ({
			position,
			hero: isHero[index],
			cards: hands[index],
			startingNormStack: stacks[index],
		}))

		const payload = {
			spot_id: spot_id,
			players: reqPlayers,
			trace: trace,
			replace_response: replaceResponse
		}

		const { data } = await API.post('get_assistance_by_data', payload)

		dispatch(handsActions.setGptAnalysisData(data))
		dispatch(handsActions.setIsLoadingGPTResponse(false))

	} catch (e) {
		dispatch(handsActions.setIsLoadingGPTResponse(false))
		dispatch(handsActions.setIsOpenAIAnalyzeModal(false))
		console.log('error', e)
	}
}
